<div class="about-background">
  <div class="about-center">
    <h1>About DOME</h1>
    <p>
      Welcome to the DOME Registry: the disclosure platform for machine learning covering Data, Optimisation, Model, & Evaluation. DOME represents a community-driven effort, originating
      within the ELIXIR Machine Learning Focus Group, to improve the transparency, reproducibility, and reusability of
      machine learning methods applied in the life sciences and beyond. It comprises two key components: the DOME
      Recommendations and the DOME Registry.
    </p>
  </div>

  <div class="white-divider" id="white-divider-1"></div>

  <div class="dome-recommendations">
    <p class="dome-recommendations-title">
      DOME Recommendations
    </p>
    <div class="progress-bar-container">
      <div class="progress-bar" id="scroll-progress"></div>
    </div>
    <div class="dome-recommendations-content">
      <p>Challenges</p>
      <p>Solution</p>
      <p>Key Principles</p>
      <p>Goals</p>
    </div>
    <div class="recoms">
      <!-- Content for Challenges (default active) -->
      <div class="recom-content active" id="recom-content-0">
        <h3>The Challenge</h3>
        <p>Machine learning (ML) is transforming scientific discovery, but describing complex ML methods adequately in
          traditional publications is challenging. This often hinders understanding, comparison, replication, and reuse,
          contributing to a "reproducibility crisis" in computational research.</p>
      </div>

      <!-- Content for Solution -->
      <div class="recom-content" id="recom-content-1">
        <h3>The Solution</h3>
        <p>The DOME Recommendations provide a structured, community-agreed-upon framework for describing ML methods.
          They offer guidelines on the essential information needed to understand and potentially replicate an ML
          application.</p>
      </div>

      <!-- Content for Key Principles -->
      <div class="recom-content" id="recom-content-2">
        <h3>Key Principles</h3>
        <p>The Recommendations focus on capturing critical details often missing from narrative descriptions, including:
          Clear identification of the ML task and model type.
          Detailed information about training, validation, and test datasets.
          Preprocessing steps and feature engineering specifics.
          Model architecture and hyperparameters.
          Training procedures and optimisation details.
          Evaluation metrics and procedures.
          Software environment and dependencies.
        </p>
      </div>

      <!-- Content for Goals -->
      <div class="recom-content" id="recom-content-3">
        <h3>Goal</h3>
        <p>To make ML methods more FAIR (Findable, Accessible, Interoperable, and Reusable) by providing a standardized
          checklist and structure for their description.
        </p>
      </div>
    </div>
    <div class="machine-learning-container">
      <div class="machine-learning">
        <img src="assets/_Group_.svg" alt="DOME Illustrations" class="dome-illustration">
        <p>Machine Learning</p>
      </div>
      <div class="transparency-container">
        <div class="transparency-box">
          <img src="assets/Vector-50.svg" alt="DOME Illustrations">
          <div class="transparency">
            <p>Transparency</p>
          </div>
          <img src="assets/Vector-51.svg" alt="DOME Illustrations">
        </div>
        <div class="transparency-box">
          <img src="assets/Vector-50.svg" alt="DOME Illustrations">
          <div class="transparency">
            <p>Documentation</p>

          </div>
          <img src="assets/Vector-51.svg" alt="DOME Illustrations">
        </div>
        <div class="transparency-box">
          <img src="assets/Vector-50.svg" alt="DOME Illustrations">
          <div class="transparency">
            <p>Reproducibility</p>
          </div>
          <img src="assets/Vector-51.svg" alt="DOME Illustrations">
        </div>
      </div>
      <div class="traditional-publications">
        <img src="assets/_Group_.svg" alt="DOME Illustrations" class="dome-illustration">

        <p>Traditional Publications</p>
      </div>
    </div>

    <div class="full-documentation-container">
      <div class="full-documentation-line"></div>
      <div class="full-documentation">
        <p>Full Documentation</p>
        <div class="full-documentation-button">
          <a href="https://dome-ml.org/" class="dome-ML">Dome ML <img src="assets/thin-arrow-right-icon.svg"
                                                                      alt="Right arrow" class="right-small-arrow">
          </a>
          <a href="https://doi.org/10.1038/s41592-021-01205-4" class="foundation-publication">Foundation Publication
            <img src="assets/thin-arrow-right-icon.svg"
                 alt="Right arrow" class="right-small-arrow"></a>
        </div>
      </div>
      <div class="full-documentation-line"></div>
    </div>

  </div>
  <div class="white-divider" id="white-divider-2"></div>
  <div class="dome-registry">
    <p class="dome-recommendations-title">
      DOME Registry
    </p>

    <div class="implementation-first-container">
      <div class="title-row">
        <div class="square"></div>
        <p class="implementation-title">Implementation</p>
      </div>
      <p class="implementation-text">
        The DOME Registry is the practical, web-based platform designed to implement the DOME Recommendations. It serves
        as a public, searchable database for detailed ML method descriptions.
      </p>

    </div>
    <div class="implementation-container">
      <div class="title-row">
        <div class="square"></div>
        <p class="implementation-title">Functionality</p>
      </div>
      <p class="implementation-text">
        Researchers can submit their method descriptions, structured according to the DOME Recommendations (often via
        the DOME Wizard tool), into the Registry. Each entry receives a persistent, unique identifier. The Registry
        allows users to submit, discover, access and cite.
      </p>

    </div>
    <div class="implementation-container">
      <div class="title-row">
        <div class="square"></div>
        <p class="implementation-title">Purpose</p>
      </div>
      <p class="implementation-text">
        To act as a central hub for FAIR ML method descriptions, complementing traditional publications by providing the
        necessary granular detail that papers often cannot accommodate. It directly supports transparency and
        reproducibility efforts.
      </p>

    </div>
    <div class="implementation-last-container">
      <div class="title-row">
        <div class="square"></div>
        <p class="implementation-title">Integration</p>
      </div>
      <p class="implementation-text">
        The Registry uses ORCID for submitter authentication and attribution, facilitates potential accreditation via
        APICURON, and aims to integrate with journal publishing workflows.
      </p>

    </div>
  </div>
  <div class="white-divider" id="white-divider-3"></div>
  <div class="dome-registry-mirroring">
    <p class="dome-recommendations-title">
      DOME Registry Mirroring
    </p>
    <div class="dome-registry-mirroring-container">
      <div class="infrastructure">
        <p class="infrastructure-title">Infrastructure</p>
        <p class="infrastructure-text">
          The DOME Registry is the practical, web-based platform designed to implement the DOME Recommendations. It
          serves
          as a public, searchable database for detailed ML method descriptions.</p>
        <a href="https://registry.dome-ml.inab.certh.gr/intro">DOME Registry Mirror<img src="assets/thin-arrow-right-icon.svg"
                                                                                  alt="Right arrow"
                                                                                  class="right-small-arrow"></a>
      </div>
      <div class="boxes">
        <div class="boxes-l">
          <div class="box-star">
            <img src="assets/Star-5.svg" alt="Star shape icon">
            <p class="box-title">
              Ensuring Resilience
            </p>
            <p class="box-text">
              To ensure the long-term availability and resilience of the valuable data within the DOME Registry, we aim
              to establish mirroring mechanisms.
            </p>
          </div>
          <div class="box-circle">
            <img src="assets/Ellipse-5.svg" alt="Circle shape icon">
            <p class="box-title">
              Benefits
            </p>
            <p class="box-text">
              This approach safeguards against single-point-of-failure scenarios, improves access speed for a global
              audience, and helps guarantee the persistence of the collected method descriptions.
            </p>
          </div>
        </div>
        <div class="boxes-r">
          <div class="box-triangle">
            <img src="assets/Polygon-1.svg" alt="Triangle shape icon">
            <p class="box-title">
              Concept
            </p>
            <p class="box-text">
              Mirroring involves maintaining synchronized copies of the Registry's database and potentially its
              interface at geographically distributed locations, often leveraging infrastructure provided by partners
              like ELIXIR Nodes.
            </p>
          </div>
          <div class="box-square">
            <img src="assets/Rectangle-45.svg" alt="Square shape icon">
            <p class="box-title">
              Status
            </p>
            <p class="box-text">
              Mirroring infrastructure is currently under development.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <app-submit></app-submit>
  <div class="dome-registry-codebase">
    <p class="dome-registry-codebase-title">
      DOME Registry Codebase
    </p>
    <div class="dome-registry-codebase-container">
      <div class="side-l">
        <div class="open-source">
          <div class="head">
            <div class="square"></div>
            <p>Open Source</p>
          </div>
          <p class="open-source-text">
            The software powering the DOME Registry is developed
            as an open-source project.
          </p>
        </div>
        <div class="open-source">
          <div class="head">
            <div class="square"></div>
            <p>Transparency & Collaboration</p>
          </div>
          <p class="open-source-text">
            Making the codebase openly available promotes transparency in how the Registry operates and allows the
            community to contribute to its development, suggest improvements, or report issues.
          </p>
        </div>
      </div>
      <div class="side">
        <div class="open-source">
          <div class="head">
            <div class="square"></div>
            <p>Accessibility</p>
          </div>
          <p class="open-source-text">
            Interested developers can view, download,
            and potentially adapt the code ( Subject to licensing terms. )
          </p>
        </div>
        <div class="open-source">
          <div class="head">
            <div class="square"></div>
            <p>Repository</p>
          </div>
          <p class="open-source-text">
            The DOME Registry codebase is hosted online on GitHub repository.
          </p>

          <a href="https://github.com/BioComputingUP/dome-registry/" class="dome-ML">View Repository<img
            src="assets/thin-arrow-right-icon.svg" alt="Right arrow" class="right-small-arrow"></a>
        </div>
      </div>
    </div>
  </div>
  <div class="white-divider" id="white-divider-4"></div>
  <div class="citing-dome">
    <h1>Citing Dome</h1>
    <div class="citing-dome-container">
      <p class="citing-dome-text">Proper citation is essential for acknowledging the use of DOME resources and tracking
        their impact. Please use
        the following guidelines:</p>
      <div class="citing-dome-box">
        <div class="head-citing-dome">
          <div class="square"></div>
          <p class="head-citing-dome-text">DOME: recommendations for supervised machine learning validation in
            biology</p>
        </div>
        <p class="citing-dome-box-text"><strong>Please cite our primary publication outlining the recommendations:</strong><br>
          Walsh, I., Fishman, D., Garcia-Gasulla, D. et al. DOME: recommendations for supervised machine learning
          validation in biology. Nat Methods 18, 1122–1127 (2021). <a href="https://doi.org/10.1038/s41592-021-01205-4">https://doi.org/10.1038/s41592-021-01205-4</a>
        </p>
      </div>
      <div class="citing-dome-box">
        <div class="head-citing-dome">
          <div class="square"></div>
          <p class="head-citing-dome-text">To Cite the DOME Registry Platform:</p>
        </div>
        <p class="citing-dome-box-text"><strong>Please cite the publication describing the registry's development and
          features</strong> :<br>
          Omar Abdelghani Attafi,& al. DOME Registry: implementing
          community-wide recommendations for reporting supervised machine learning in biology, GigaScience, Volume 13,
          2024, giae094, <a href="https://doi.org/10.1093/gigascience/giae094">https://doi.org/10.1093/gigascience/giae094</a><br>
        </p>
      </div>
      <div class="citing-dome-box">
        <div class="head-citing-dome">
          <div class="square"></div>
          <p class="head-citing-dome-text">To Cite a Specific Method Entry in the Registry:</p>
        </div>
        <p class="citing-dome-box-text">Please use the persistent identifier (e.g., DOI or other persistent ID) assigned
          to the specific method entry
          upon its submission. The exact citation format will typically be provided on the entry's page within the
          Registry.<br>
          Example Format: Creator(s) (Year). Title of Method Entry. DOME Registry, Identifier: [Persistent ID],
          Accessed [Date].</p>
      </div>
    </div>
  </div>
  <app-big-footer></app-big-footer>

</div>
